module.exports = "/_next/static/images/GainCompleteViewOfYourCustomers-eaaee3292a2a207c14e2d550effa503c.webp";